/*
 * The cars in the workshop on Ejar that have no open maintenance record here (owner, 18 Oct 2026: "any car on Ejar
 * with Maintenance status at Business Bay is really in maintenance"; 29 Oct 2026: Invygo too). The list itself comes
 * from the engine's Overview rule (GET /api/overview/list?what=maintenance - api/overview.py car_state), so this page
 * and the Overview's "In maintenance" figure never disagree; here we only take away the cars that already have a log.
 */

/** Cars of the engine's maintenance list with no open log (a log without Date IN), sorted by plate. */
export const carsWithoutOpenLog = (ejarCars, logs, normalizePlate) => {
    const open = new Set((logs || [])
        .filter((r) => !String(r?.['Date IN'] || '').trim())
        .map((r) => normalizePlate(r?.Vehicle))
        .filter(Boolean));
    return (ejarCars || [])
        .filter((c) => {
            const p = normalizePlate(c?.plate);
            return p && !open.has(p);
        })
        .sort((a, b) => String(a.plate).localeCompare(String(b.plate)));
};
